import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { IContextMenuOptions } from './ApplicationMenu';
import { ApplicationMenuContainerProps } from './ApplicationMenuContainer';

type MenuContextState = ApplicationMenuContainerProps & {
  setOptions: Dispatch<SetStateAction<IContextMenuOptions>>;
};

const MenuContext = createContext<MenuContextState | null>(null);

export const useMenuContext = (): MenuContextState => {
  const ctx = useContext(MenuContext);
  if (!ctx) throw new Error('No FormContext');
  return ctx as MenuContextState;
};

export default MenuContext;
